import React, { useEffect, useState, useRef } from "react"
import { Button, Modal } from "antd"
import ReactPlayer from "react-player"
import Closecircle from "../../assets/images/Closecircle.png"
import tourimage from "../../assets/images/tourimage.png"
import commonStrings from "../commonStrings"
import { getCurrentVideoSource, formatStepCounter } from "../utilities"

const TourVideo = ({
  title,
  description,
  currentStep,
  totalSteps,
  handleNext,
  handleSkip,
  handleBack,
  videoUrls,
}) => {
  const [playVideo, setPlayVideo] = useState(true)
  const [isReplayVisible, setIsReplayVisible] = useState(false)
  const headerRef = useRef(null) // Ref for scrolling

  useEffect(() => {
    setIsReplayVisible(false)
    setPlayVideo(true)

    // Scroll to top of the header when the step changes
    if (headerRef.current) {
      headerRef.current.scrollTo({ top: 0, behavior: "smooth" })
    }
  }, [currentStep])

  const handleReplay = () => {
    setPlayVideo(false)
    setTimeout(() => {
      setPlayVideo(true)
      setIsReplayVisible(false)
    }, 0)
  }

  const handleVideoPlay = () => {
    setIsReplayVisible(false)
  }

  const handleVideoEnd = () => {
    setIsReplayVisible(true)
  }

  const handleNextStep = () => {
    handleNext() // Call the original next function

    // Scroll the header div to the top when clicking "Next"
    if (headerRef.current) {
      headerRef.current.scrollTo({ top: 0, behavior: "smooth" })
    }
  }

  return (
    <div>
      <Modal
        keyboard
        title={currentStep === 0 ? title : null}
        visible
        className={`modal-container tour-modal ${
          currentStep !== 0 ? "step-not-zero" : "step-zero"
        }`}
        onCancel={handleSkip}
        footer={null}
        closeIcon={(
          <div className="custom-close-icon">
            <img
              className="close-tour-icon"
              src={Closecircle}
              alt="Close Icon"
            />
          </div>
        )}
      >
        <div className="tutorial-content">
          <div className="video-container-tour">
            {currentStep === 0 ? (
              <img
                src={tourimage}
                alt="TourVideo Step"
                className="tour-image"
                style={{ width: "850px", height: "510px" }}
              />
            ) : (
              <div>
                <ReactPlayer
                  url={getCurrentVideoSource(videoUrls, currentStep)}
                  playing={playVideo}
                  controls={false}
                  className="videos-section-tour"
                  onPlay={handleVideoPlay}
                  onEnded={handleVideoEnd}
                />
              </div>
            )}
          </div>

          <div className="main-tour-header">
            <div
              className="inner-main-tour-header"
              ref={headerRef}
              style={{ maxHeight: "200px", overflowY: "auto" }}
            >
              <div className="tour-description">
                <span>{description}</span>
              </div>
            </div>
          </div>
          <div className="tour-footer">
            <div className="tour-step-counter">
              <span>{formatStepCounter(currentStep, totalSteps)}</span>
            </div>
            <div className="tour-buttons">
              {currentStep + 1 !== totalSteps && (
                <Button
                  className="skipbutton-tour"
                  key="skip"
                  onClick={handleSkip}
                >
                  {commonStrings.skip}
                </Button>
              )}
              {currentStep > 0 && (
                <Button
                  className="backbutton-tour"
                  key="back"
                  type="primary"
                  onClick={handleBack}
                >
                  {commonStrings.back}
                </Button>
              )}
              {currentStep + 1 === totalSteps ? (
                <Button
                  className="finishbutton-tour"
                  key="finish"
                  type="primary"
                  onClick={handleSkip}
                >
                  {commonStrings.finish}
                </Button>
              ) : (
                <Button
                  className="nextbutton-tour"
                  key="next"
                  type="primary"
                  onClick={handleNextStep}
                >
                  {commonStrings.next}
                </Button>
              )}
              {isReplayVisible && (
                <div className="button-tour-replay">
                  <Button
                    onClick={handleReplay}
                    type="primary"
                    className="replay-video-button"
                  >
                    {commonStrings.replayTutorial}
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default TourVideo
